// Soft multi-hue brand gradient. Shared by the homepage intro panel, header, and footer.
export const BRAND_GRADIENT =
	'linear-gradient(120deg, #f5f3ff 0%, #eef4ff 28%, #ecfeff 55%, #fef3f8 82%, #fff7ed 100%)';
